import {APP_GHA_BIDDING_API_ENDPOINT,} from "constants/api_urls";
import "../style/chartContainer.scss";

export const urlActiveMultiplierHistoryPopover = {
    "GHA_META": `${APP_GHA_BIDDING_API_ENDPOINT}`,
    "GHA_PPA": `${APP_GHA_BIDDING_API_ENDPOINT}`
}